import CustomLoader from "../Loader";

export const LoaderWrapper = ({ loading, children }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      <CustomLoader visible={loading} />
      {children}
    </div>
  );
};
